import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex w-full flex-1 flex-col items-center justify-center px-4 py-20 text-center md:py-28">
        <p className="font-heading text-6xl font-black leading-none text-primary-500 md:text-8xl">404</p>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这个页面走丢了</h1>
        <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
          我们没能找到你要访问的页面。可能是链接已经调整，或者内容暂时下线了。回到首页或热点聚合页继续浏览吧。
        </p>
        <p className="mt-3 rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-home-4-line text-base"></i>
            返回首页
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            <i className="ri-fire-line text-base"></i>
            浏览热点聚合
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}